import { useTranslation } from 'react-i18next';
import { Button } from '~/components/ui';

export function ImportActions({
  onBack,
  backLabel,
  importable,
  blocked,
  isImporting,
  onImport,
}: {
  onBack: () => void;
  backLabel: string;
  importable: number;
  blocked: number;
  isImporting: boolean;
  onImport: () => void;
}) {
  const { t } = useTranslation('inventory-import');
  return (
    <div className="flex items-center gap-3 border-t border-neut-border pt-4">
      <Button variant="secondary" size="sm" width="auto" onClick={onBack}>
        {backLabel}
      </Button>
      <Button
        variant="primary"
        size="sm"
        width="auto"
        disabled={importable === 0 || isImporting}
        loading={isImporting}
        onClick={onImport}
      >
        {t('review.import_rows', { count: importable })}
      </Button>
      {blocked > 0 && (
        <span className="text-sm text-neut-sec">
          <strong className="text-error-600">{blocked}</strong>{' '}
          {t('review.blocked_by_errors')}
        </span>
      )}
    </div>
  );
}
